import { formatDateTime } from '../../../helpers/Date/Date';

export const dateTimeFormatter = (user: string, date: string): string => {
    return `${user} ${formatDateTime(date)}`;
};
